module.exports = __webpack_public_path__ + "static/img/142.44a054d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/142.png
// module id = wRM3
// module chunks = 0